import { TohumUiModule } from '@anadolu-commons/tohum-ui';
import { OnInit, OnDestroy, EventEmitter, Component, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { interval, Subscription } from 'rxjs';


@Component({
  selector: 'aof-sayac',
  standalone: true,
  imports: [TohumUiModule],
  template: '',
})

export class SayacComponent implements OnInit, OnDestroy, OnChanges {

  @Input() sure: number;
  @Input() sayacAktifMi: boolean;
  @Output() sureBitti = new EventEmitter();
  
  private sureSubscription: Subscription;
  private bitis: number;
  private tempSure: number;

  constructor() {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.sayacAktifMi) { }
    else {
      if (this.sureSubscription) {
        this.sureSubscription.unsubscribe();
      }
    }
  }

  ngOnInit(): void {

    if (this.sureSubscription) {
      this.sureSubscription.unsubscribe();
    }

    this.sifirla();
    
    this.sureSubscription = interval(500).subscribe(() => {

      this.tempSure = this.bitis - Date.now();

      if (this.tempSure < 0) {
        this.sureBitti.emit();
        this.sifirla();
      }

    });
    
  }

  sifirla() {
    this.tempSure = this.sure;
    this.bitis = new Date(Date.now() + this.tempSure).getTime();
  }

  ngOnDestroy(): void {
    if (this.sureSubscription) {
      this.sureSubscription.unsubscribe();
    }
  }

}
